import { TransportEmployeeNumber } from "../../../store/types/userTypes";

export type RegistrationMode = "entry" | "exit";
export type RegistroIngresoNavigationIntent = "replace-session" | "append-tab" | "keep-session";

export type RegistroIngresoPrefill = {
  eventId?: string;
  id?: string;
  comment?: string;
  documentCountry?: string;
  documentNumber?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  birthdate?: string | Date | null;
  sex?: string;
  visitorPhoto?: string;
  frontDNI?: string;
  backDNI?: string;
  insuranceExpirationDate?: string | Date | null;
  insurancePhoto?: string;
  vtvExpirationDate?: string | Date | null;
  vtvPhoto?: string;
  technicalReviewPhoto1?: string;
  technicalReviewPhoto?: string;
  vehiclePlate?: string;
  vehicleType?: string;
  vehicleBrand?: string;
  vehicleModel?: string;
  vehicleColor?: string;
  selectedVehicleId?: string | null;
  /** Ficha completa de la unidad elegida en el modal de salida. No viaja al backend: se usa sólo
   * para hidratar el formulario antes de que termine la búsqueda del chofer. */
  exitVehicle?: any;
  /** Acoplados que salen junto al vehículo principal. Se mandan como `trailers: string[]` en el
   * addEvent; el id evita que `resolveTrailerVehicles` vuelva a crearlos. */
  trailerVehicles?: { id?: string; vehiclePlate?: string }[];
  /** El guardia ya eligió qué unidades salen en el modal de salida, así que `trailerVehicles` es la
   * selección final: un array vacío significa "sale sin acoplados", no "todavía no se cargó". */
  exitUnitsPreselected?: boolean;
  /** La persona sale a pie y deja sus unidades adentro. En transporte no alcanza con
   * `vehicleType: "none"`: el medio de acceso se fuerza a "car" y la patente se recupera de la
   * autorización de egreso, así que hace falta decirlo explícito. */
  exitOnFoot?: boolean;
  inEventComment?: string;
  inEventPeopleComment?: string;
  inEventPhoto?: string;
  inEventPhoto2?: string;
  inEventPhoto3?: string;
  entranceEvent?: any;
  /** Legajo del chofer tal como lo devolvió `getPeopleInside` para el ingreso que se está cerrando. */
  transportEmployeeNumber?: string;
  transportEmployeeNumbers?: TransportEmployeeNumber[];
  observationsText?: string;
  peopleComment?: string;
  company?: string;
  passId?: string;
  passType?: string;
  passGuestsType?: string;
  isBuildingMismatch?: boolean;
};

export type RegistroIngresoNavigationState = {
  mode?: RegistrationMode;
  intent?: RegistroIngresoNavigationIntent;
  prefill?: RegistroIngresoPrefill;
};

export const isRegistrationMode = (value: unknown): value is RegistrationMode => {
  return value === "entry" || value === "exit";
};

export const isRegistroIngresoNavigationIntent = (
  value: unknown
): value is RegistroIngresoNavigationIntent => {
  return value === "replace-session" || value === "append-tab" || value === "keep-session";
};
